import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header, Footer } from "@/site/Chrome";
import { Hero } from "@/site/Hero";
import { Services } from "@/site/Services";
import { Projects } from "@/site/Projects";
import { Commercial, Domestic } from "@/site/Sectors";
import { WhyUs, Areas, HowItWorks } from "@/site/InfoSections";
import { Faq } from "@/site/Faq";
import { QuoteForm } from "@/site/QuoteForm";
import { FloatingContact } from "@/site/FloatingContact";
import { useReveal } from "@/site/hooks";

const Home = () => {
  useReveal();

  return (
    <div className="min-h-screen bg-[#111923] text-[#eef4f8] antialiased selection:bg-[#00c2a8] selection:text-[#111923]">
      <Header />
      <main>
        <Hero />
        <Services />
        <Projects />
        <Commercial />
        <Domestic />
        <WhyUs />
        <Areas />
        <HowItWorks />
        <Faq />
        <QuoteForm />
      </main>
      <Footer />
      <FloatingContact />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#182330",
            border: "1px solid #213042",
            color: "#eef4f8",
            fontFamily: 'ui-monospace, "SF Mono", Menlo, Consolas, monospace',
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
